import { gql } from 'graphql-request';

import {
  TaskBurning,
  TaskID,
  TaskImplementationDate,
  TaskLdCustomerID,
  TaskLdProductID,
  TaskLdSku,
  TaskName,
  TaskNanoID,
  TaskProjectID,
  TaskProjectName,
  TaskProjectNanoID,
  TaskProjectOwnerClient,
  TaskProjectOwnerID,
  TaskProjectTeamImageFile,
  TaskProjectTeamName,
  TaskProjectTeamNanoID,
  TaskProjectTeamUseLdApiAt,
  TaskProjectUUID,
  TaskSku,
  TaskState,
  TaskStatus,
  TaskUUID,
  TaskVersionMessageBody,
  TaskVersionMessageID,
  TaskVersionMessageUUID,
  TaskVersionNumber,
  TaskVisibleForClient
} from '../tasksTypes';
import {
  MessageTaskMark,
  MessageTaskSupportMark
} from '../../messages/messagesTypes';
import { TeamUUID } from '../../teams/teamsTypes';

export interface FetchShowTaskQueryResponse {
  id: TaskID;
  uuid: TaskUUID;
  nanoId: TaskNanoID;
  name: TaskName;
  status: TaskStatus;
  burning: TaskBurning;
  visibleForClient: TaskVisibleForClient;
  mark: MessageTaskMark;
  supportMark: MessageTaskSupportMark;
  implementationDate: TaskImplementationDate;
  ldCustomerId: TaskLdCustomerID;
  ldProductId: TaskLdProductID;
  ldSku: TaskLdSku;
  project: {
    id: TaskProjectID;
    uuid: TaskProjectUUID;
    nanoId: TaskProjectNanoID;
    name: TaskProjectName;
    team: {
      name: TaskProjectTeamName;
      nanoId: TaskProjectTeamNanoID;
      uuid: TeamUUID;
      image: {
        file: TaskProjectTeamImageFile;
      };
      useLdApiAt: TaskProjectTeamUseLdApiAt;
    };
    owner: {
      id: TaskProjectOwnerID;
      client: TaskProjectOwnerClient;
    };
  };
  state: TaskState;
  sku: TaskSku;
  versionNumber: TaskVersionNumber;
  versionMessage: {
    id: TaskVersionMessageID;
    uuid: TaskVersionMessageUUID;
    body: TaskVersionMessageBody;
  };
}

export const FETCH_SHOW_TASK_QUERY = gql`
  query ShowTask($uuid: ID!) {
    task(uuid: $uuid) {
      id
      uuid
      nanoId
      name
      status
      burning
      visibleForClient
      mark
      supportMark
      implementationDate
      ldCustomerId
      ldProductId
      ldSku
      project {
        id
        uuid
        nanoId
        name
        team {
          name
          nanoId
          uuid
          image {
            file
          }
          useLdApiAt
        }
        owner {
          id
          client
        }
      }
      versionNumber
      versionMessage {
        id
        uuid
        body
      }
      state
      sku
    }
  }
`;
